import { Component } from '@angular/core';
import { ReportResponseService } from '../../services/report_response.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { AssistanceSystemConfigService } from '../../../shared/services/assistance-system-config.service';


@Component({
  selector: 'app-create-report',
  templateUrl: './create-report.component.html',
  styleUrl: './create-report.component.scss'
})
export class CreateReportComponent {
  activeTab: string = 'tab1';
  ecclesiasticDataTabVisible: boolean = true;

  constructor(
      private reportResponseService: ReportResponseService,
      private route: ActivatedRoute,
      private router:Router,
      private assistanceSystemConfigService: AssistanceSystemConfigService
    ){}

    ngOnInit(): void {
      this.reportResponseService.dataToEdit$.subscribe(data=>{
        if(data){
          this.changeTab('tab3')
        }
      })
      this.changeTab("tab1");

      this.assistanceSystemConfigService.isEcclesiasticDataEnabled().subscribe(enabled => {
        this.ecclesiasticDataTabVisible = enabled;
        if (!enabled && this.activeTab === 'tab4') {
          this.changeTab('tab1');
        }
      });
    }

    changeTab(tabId: string): void {
      if(tabId === "tab2") {
        this.reportResponseService.setSelectedReportResponseId('');
      }
      this.activeTab = tabId;
    }
}
